import { render, staticRenderFns } from "./Rainbow.vue?vue&type=template&id=fd1bbac4&scoped=true"
var script = {}
import style0 from "./Rainbow.vue?vue&type=style&index=0&id=fd1bbac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1bbac4",
  null
  
)

export default component.exports